



















import { mapGetters } from 'vuex'
import Vue from 'vue'
export default Vue.extend({
    props: {
        label: {
            type: String,
            required: false,
            default: 'Select View'
        }
    },
    computed: {
        ...mapGetters(['groupsBuckets'])
    },
    methods: {
        //  Returns the color of the icon
        bucketColor(group: { bucket: { color: string } }): string {
            //  Check if the group has a bucket color
            const hasColor = group.bucket && group.bucket.color

            //  If the group does NOT have a color, return default
            if (!hasColor) return 'primary'

            //  Else, return the bucket's assigned color
            return group.bucket.color
        }
    }
})
